// import { pdf } from '@react-pdf/renderer';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../services/GlobalVariables'
// import SalesInvoicePDF from '../../components/StockReports/SalesInvoicePDF'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'feedback/'

const initialState = {
    masterData: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const addFeedback = createAsyncThunk('br/brList', async (fbData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'addfeedback', fbData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const feedbackSlice = createSlice({
    name: 'menus',
    initialState,
    reducers: {
        reset: (state) => {
            state.masterData = []
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(addFeedback.pending, (state) => {
                state.isLoading = true
            })
            .addCase(addFeedback.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.masterData = action.payload
            })
            .addCase(addFeedback.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
    }
})

export const { reset } = feedbackSlice.actions

export default feedbackSlice.reducer

